import React from 'react'
import styles from './styles.module.scss'
import PropTypes from 'prop-types'
import Button from '../Button'
import Icon from 'srcReact/components/icons/Icon'
import ReviewActionButtonPure from './ReviewActionButtonPure'

function ReviewActionButton({ className, text, color, handleClick, iconName }) {
  return (
    <ReviewActionButtonPure
      text={text}
      color={color}
      handleClick={handleClick}
      iconName={iconName}
      className={className}
      renderButton={(text, color, iconName, handleClick) => (
        <div className={`${styles.flaggedButtonWrapper} ${className}`}>
          <Button
            text={text}
            iconPosition='start'
            customStyle={`${styles.button} ${styles[color]}`}
            icon={<Icon name={iconName} size='large24' />}
            icon2={handleClick && <Icon name='arrow-right' size='large24' />}
            handleClick={handleClick}
          />
        </div>
      )}
    />
  )
}

ReviewActionButton.propTypes = {
  text: PropTypes.string,
  className: PropTypes.string,
  color: PropTypes.string,
  handleClick: PropTypes.func
}

export default ReviewActionButton
